<template>
    <div class="home-welcome">
        <div class="home-welcome__content">
            <h2 class="home-welcome__title">追求卓越</h2>
            <p class="home-welcome__sub-title">In Search Of Excellence</p>
            <div>
                <app-button class="home-welcome__subscribe-button" to="subscribe">
                    <app-icon value="icon-add"/>
                    订阅
                </app-button>
            </div>
        </div>
        <div class="home-welcome__banner">
            <img src="http://cdn.airfunc.com/undraw_web_developer_p3e5.svg">
        </div>
    </div>
</template>

<script>
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'

    export default {
        name: "Welcome",
        components: {
            AppButton,
            AppIcon
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .home-welcome {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: $paddingMD;

        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeLG;
            font-weight: $fontWeightBold;
            @include transition-colors;
        }

        &__sub-title {
            margin-top: $paddingSM;
            color: $primaryColor;
            color: var(--primaryColor);
            font-size: $fontSize;
            @include transition-colors;
        }

        &__subscribe-button {
            display: inline-block;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            color: #fff;
            background-color: $darkPrimaryColor;
            margin-top: $paddingMD;
            @include transition-colors;

            .app-icon {
                font-weight: $fontWeightBolder;
                color: #fff;
                margin-right: $paddingSM;
            }

            &:hover {
                color: #fff;
                background-color: $primaryColor;

                .app-icon {
                    color: #fff;
                }
            }
        }

        &__content {
            text-align: center;
            margin-bottom: $paddingLG;
            width: 100%;
            /*width: 30%;*/
            /* padding-right: $paddingMD;*/
        }

        &__banner {
            width: 100%;
            /*width: 70%;*/
        }

    }

    @media (min-width: 1024px) {
        .home-welcome {
            &__content {
                text-align: left;
                margin-bottom: 0;
                width: 30%;
                padding-right: $paddingMD;
            }

            &__banner {
                width: 70%;
            }

            /*flex-direction: row;*/

            /*&__content {*/
            /*    width: 66.6667%;*/
            /*    padding-right: 0;*/
            /*}*/

            /*&__thumb {*/
            /*    width: 33.3333%;*/
            /*    margin-bottom: 0;*/
            /*}*/
        }
    }
</style>